import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_CATEGORY_EDIT,
  IN_ROOM_DINING_CATEGORY_TAB_LIST,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { inRoomDiningCategorySelector } from '../../../servicesSlice';
import CategoryViewDetails from './Category-View-Details';
import './Category-View.scss';

const InRoomDiningCategoryView = (props) => {
  const { category, toggleDrawer, onViewToggle, permissions } = props;
  const inRoomDiningCategory = useSelector(inRoomDiningCategorySelector);
  const [tabValue, setTabValue] = useState(0);
  const [currCategory, setCurrCategory] = useState(null);
  useEffect(() => {
    if (inRoomDiningCategory.length) {
      let categoryObj = {
        ...inRoomDiningCategory.find((tempCategoryInfo) => tempCategoryInfo.id === category.id),
      };
      setCurrCategory(categoryObj);
    }
  }, [inRoomDiningCategory]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, currCategory);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(IN_ROOM_DINING_CATEGORY_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <CategoryViewDetails tabValue={tabValue} category={currCategory} />;
  };

  return (
    <>
      {currCategory && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={IN_ROOM_DINING_CATEGORY_TAB_LIST}
          onViewToggle={onViewToggle}
          title={currCategory.name}
          createdUserId={currCategory.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default InRoomDiningCategoryView;
